import { __spreadArrays } from "tslib";
import BatchAutoConfigLayers from '../BatchAutoConfig/layers';
var layers = [
    {
        key: 'SettingPop',
        getComponent: function () { return import('./Setting/SettingPop'); },
        width: 400,
        title: '',
        maskClosable: false,
        timeout: 500,
    },
];
export default __spreadArrays(layers, BatchAutoConfigLayers);
